import React from 'react';

/**
 * Frosted metric tile for Lab Data dashboards.
 *
 * @param {Object} props
 * @param {string} props.label
 * @param {React.ReactNode} props.value
 * @param {React.ReactNode} [props.subtitle]
 */
const LabDataKpiCard = ({ label, value, subtitle }) => (
  <div className="lab-data-kpi">
    <p className="lab-data-kpi__label">{label}</p>
    <p className="lab-data-kpi__value">{value}</p>
    {subtitle ? <p className="lab-data-kpi__subtitle">{subtitle}</p> : null}
  </div>
);

export default LabDataKpiCard;
